var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.81339 1.4732C2.4484 1.4732 1.31639 2.57803 1.28429 3.94055V12.8575C1.26041 14.2134 2.33643 15.3265 3.68249 15.3495L3.80351 15.3487H10.3996C11.7514 15.3339 12.8538 14.2167 12.8521 12.8583V5.44962L9.03707 1.4732H3.82327H3.81339ZM3.67096 16.5844C1.635 16.549 0.0147938 14.872 0.0493714 12.8468V3.92573C0.0962982 1.88319 1.78319 0.238281 3.81092 0.238281H3.82574H9.2997C9.46765 0.238281 9.62819 0.306613 9.74509 0.427635L13.9158 4.77371C14.0253 4.88814 14.087 5.0421 14.087 5.20099V12.8575C14.0903 14.8901 12.4389 16.5622 10.4062 16.5836L3.67096 16.5844Z",
    fill: "#5D6373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4666 5.97827H11.1992C9.69183 5.97416 8.4668 4.74583 8.4668 3.24088V0.845973C8.4668 0.505136 8.74342 0.228516 9.08425 0.228516C9.42509 0.228516 9.70171 0.505136 9.70171 0.845973V3.24088C9.70171 4.06745 10.3743 4.74089 11.2009 4.74336H13.4666C13.8074 4.74336 14.084 5.01998 14.084 5.36082C14.084 5.70165 13.8074 5.97827 13.4666 5.97827Z",
    fill: "#5D6373"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93389 9.83062H4.90066C4.55982 9.83062 4.2832 9.554 4.2832 9.21316C4.2832 8.87232 4.55982 8.5957 4.90066 8.5957H8.93389C9.27472 8.5957 9.55135 8.87232 9.55135 9.21316C9.55135 9.554 9.27472 9.83062 8.93389 9.83062Z",
    fill: "#5D6373"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91824 11.849C6.5774 11.849 6.30078 11.5724 6.30078 11.2316V7.19754C6.30078 6.8567 6.5774 6.58008 6.91824 6.58008C7.25907 6.58008 7.5357 6.8567 7.5357 7.19754V11.2316C7.5357 11.5724 7.25907 11.849 6.91824 11.849Z",
    fill: "#5D6373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlus);
export default __webpack_public_path__ + "static/media/paperPlus.bbda7dbaecd1bb1c78878e072f5be05f.svg";
export { ForwardRef as ReactComponent };